import * as React from 'react';

import { defaultCustomerFamily } from '../quotingAPI';

import Questionnaire from './Questionnaire';
import Button from '../../components/buttons/Button';
import { IconChevronLeft, IconChevronRight } from '../../components/icons';
import WorkflowStep from '../WorkflowStep';
import Fieldset from '../../components/forms/Fieldset';

interface Props {
	assessment: any;
	customerDetails: CustomerDemographicDetails;
	customerFamilyList: CustomerFamily[];
	actions: any;
	onCustomerDetailsChange: (e: any) => void;
	onCustomerDetailsNumberKeyUp: (e: any) => void;
	history: any;
	match: any;
}
class AdvisoryQuestionnairePage extends React.Component<Props, any> {
	onAssessmentChange = (e: any) => {
		let value = e.target.value;
		if (e.target.type === 'radio') {
			if (value === 'true') {
				value = true;
			} else if (value === 'false') {
				value = false;
			}
		} else if (e.target.type === 'checkbox') {
			value = e.target.checked;
		}

		const assessment = {
			...this.props.assessment,
			[e.target.name]: value
		};

		this.props.actions.setQuotingAssessment(assessment);
	}

	onAssessmentChildrenChange = (e: any) => {
		const value = e.target.value.replace(/[^\d]/g, '');
		const numChildren = parseInt(value, 10) || 0;
		if (numChildren < 0 || numChildren > 100) {
			return;
		}
		const defaultChild: CustomerFamily = {
			...defaultCustomerFamily
		};
		const childrenAge = Array(numChildren).fill(null);
		const assessment = {
			...this.props.assessment,
			[e.target.name]: value,
			childrenAge
		};

		this.props.actions.setQuotingAssessment(assessment);

		const customerFamilyList = Array(numChildren).fill(defaultChild);

		this.props.actions.setCustomerFamilyList(customerFamilyList);
	}

	onAssessmentChildChange = (e: any, index: number) => {
		const childAge = e.target.value.replace(/[^\d]/g, '');
		const childAgeInt = parseInt(childAge, 10) || 0;
		if (childAgeInt < 0) {
			return;
		}

		const childrenAge = [...this.props.assessment.childrenAge];
		childrenAge[index] = childAge;
		const assessment = {
			...this.props.assessment,
			childrenAge
		};
		this.props.actions.setQuotingAssessment(assessment);

		const customerFamilyList = this.props.customerFamilyList.map((family, i) => {
			return { ...family, age: childrenAge[i] };
		});
		this.props.actions.setCustomerFamilyList(customerFamilyList);
	}

	back = () => {
		this.props.history.push(`/quote/${this.props.match.params.workflow}/about-you`);
	}

	isNextDisabled = () => {
		if (!this.props.assessment.numChildren
			|| !this.props.customerDetails.mortgage
			|| !this.props.customerDetails.otherDebt
			|| !this.props.customerDetails.beneficiaryAmountPerYear
			|| !this.props.customerDetails.beneficiaryAmountTotalYears
			|| !this.props.customerDetails.savingsAmount
			|| !this.props.customerDetails.existingLifeInsurance
		) {
			return true;
		}

		return false;
	}

	next = () => {
		this.props.history.push(`/quote/B/select-your-policy`);
	}

	render() {
		return (
			<WorkflowStep
				title={`Let’s determine how much coverage you need.`}
			>
				<div className="mt-5 text-center">
					<div>
						<p className="mx-auto max-read-width">Already know how much coverage you need?</p>
						<Button to="/quote/Custom/select-your-policy" className="btn-primary workflow-progress-action col-4">
							Skip
						</Button>
					</div>
				</div>
				<Fieldset>
					<Questionnaire
						assessment={this.props.assessment}
						customerDetails={this.props.customerDetails}
						onAssessmentChange={this.onAssessmentChange}
						onAssessmentChildrenChange={this.onAssessmentChildrenChange}
						onAssessmentChildChange={this.onAssessmentChildChange}
						onCustomerDetailsChange={this.props.onCustomerDetailsChange}
						onCustomerDetailsNumberKeyUp={this.props.onCustomerDetailsNumberKeyUp}
					/>
				</Fieldset>
				<div className="workflow-progress-actions">
					<Button onClick={this.back} className="btn-outline-primary workflow-progress-action">
						<IconChevronLeft />
						<span className="align-middle mx-2 d-none d-sm-inline-block">Back</span>
					</Button>
					<Button
						onClick={this.next}
						className="btn-primary workflow-progress-action"
						disabled={this.isNextDisabled()}
					>
						<span className="align-middle mx-2">Calculate my need</span>
						<IconChevronRight />
					</Button>
				</div>
			</WorkflowStep>
		);
	}
}

export default AdvisoryQuestionnairePage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/advisory/AdvisoryQuestionnairePage.tsx